import { useState } from "react";
import { LuxDialog, SpecRow } from "../common/LuxDialog";
import { LuxButton } from "../common/Primitives";
import { IMG } from "../../config/site";
import { useUI } from "../../context/UIContext";

const VIEWS = [
  { id: "signature", label: "TOYAM signature", src: IMG.bottle, alt: "TOYAM Alkaline Water 750 ml glass bottle", pos: "center" },
  { id: "label", label: "Label detail", src: IMG.bottleMaster, alt: "Close view of the TOYAM Alkaline Water label and gold emblem", pos: "center 62%", zoom: true },
  { id: "cobrand", label: "Co-brand concept", src: IMG.cobrand, alt: "Co-branding concept: TOYAM bottle between two bottles with sample hotel labels", pos: "50% center" },
];

const Magnifier = ({ view }) => {
  const [o, setO] = useState({ x: 50, y: 50, on: false });
  const move = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setO({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100, on: true });
  };
  const base = view.zoom ? 2 : 1;
  return (
    <div className="relative aspect-[3/4] cursor-zoom-in overflow-hidden bg-[#EDE1CA]" onMouseMove={move} onMouseLeave={() => setO((p) => ({ ...p, on: false }))} data-testid="bottle-viewer">
      <img src={view.src} alt={view.alt} className="h-full w-full object-cover transition-transform duration-500 ease-out"
        style={{ objectPosition: view.pos, transformOrigin: `${o.x}% ${o.y}%`, transform: `scale(${o.on ? base + 0.8 : base})` }} />
      <span className="absolute bottom-3 left-3 bg-[#21170F]/70 px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-[#E8D6B7]">Design concept · hover to inspect</span>
    </div>
  );
};

export const BottleDetails = () => {
  const { panel, closePanel, openEnquiry } = useUI();
  const [view, setView] = useState(VIEWS[0]);
  return (
    <LuxDialog open={panel === "bottle"} onClose={closePanel} eyebrow="The Bottle" title="Signature 750 ml" wide testid="bottle-details-dialog">
      <div className="grid gap-10 md:grid-cols-[1fr_1fr]">
        <div>
          <Magnifier view={view} />
          <div className="mt-4 grid grid-cols-3 gap-2" role="tablist" aria-label="Bottle views">
            {VIEWS.map((v) => (
              <button key={v.id} type="button" role="tab" aria-selected={view.id === v.id} onClick={() => setView(v)} data-testid={`bottle-view-${v.id}`}
                className={`border px-2 py-3 text-[10px] font-bold uppercase tracking-[0.16em] transition-colors duration-300 ${view.id === v.id ? "border-[#26231F] bg-[#26231F] text-[#F8F3E9]" : "border-[#B18A4A]/40 text-[#26231F] hover:border-[#26231F]"}`}>
                {v.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="body-lux">TOYAM Alkaline Water in a tall glass bottle with a tapered shoulder, narrow neck, black screw cap and minimal gold-emblem label — designed to bring quiet elegance to the table.</p>
          <dl className="mt-6">
            <SpecRow label="Product" value="Alkaline water" />
            <SpecRow label="Capacity" value="750 ml" />
            <SpecRow label="Packaging" value="Glass" />
            <SpecRow label="Intended use" value="Hospitality" />
            <SpecRow label="Availability" value="Subject to confirmation" />
            <SpecRow label="Returnable packaging" value="Subject to the operational programme" />
          </dl>
          <p className="mt-6 text-xs leading-relaxed text-[#746D64]">Imagery shows a design concept. Final dimensions and specifications will be confirmed with the production bottle.</p>
          <LuxButton arrow className="mt-8 w-full sm:w-auto" onClick={() => openEnquiry("Sample request")} data-testid="bottle-dialog-sample-btn">Request a sample</LuxButton>
        </div>
      </div>
    </LuxDialog>
  );
};
